import React from "react";
import { connect } from "react-redux";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import CatalogueCard from "components/CatalogueCard";
import { loadProducts } from "modules/playground/action";
import { getProducts } from "modules/playground/selectors";
import { isLoggedIn } from "modules/session/selectors";

const Container = styled.div`
  padding: 32px;
  width: 270px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 8px;
`;

function CataloguePage(props) {
  React.useState(() => {
    if (props.isLoggedIn) {
      props.loadProducts();
    }
  }, []);

  const products = props.products ? props.products : "";

  return (
    <Container>
      {Object.values(products).map(items => (
        <Link to={`/play/catalogue/${items.id}`}>
          <CatalogueCard name={items.name} point={items.price} image={items.image} />
        </Link>
      ))}
    </Container>
  );
}

const withConnect = connect(
  state => ({
    products: getProducts(state),
    isLoggedIn: isLoggedIn(state),
  }),
  { loadProducts }
);

export default withConnect(CataloguePage);
